import { forwardRef, useMemo } from 'react';
import Input from 'Components/Atoms/Input/Input';
import PropTypes from 'prop-types';
import { cn } from 'Utils/cn';
import { isNumber } from 'Utils/validation';

const InputCurrency = forwardRef(function InputCurrency(props, ref) {
    const { prefix = '', className, onChange, max, min, error, ...rest } = props;

    const hasMax = isNumber(max);
    const hasMin = isNumber(min);

    const handleChange = (e) => {
        onChange?.(e.target.value);
    };

    const spaceClassName = useMemo(() => {
        if (prefix.length === 1) {
            return 'pl-8';
        } else if (prefix.length === 2) {
            return 'pl-10';
        } else if (prefix.length > 2) {
            return 'pl-13';
        }

        return '';
    }, [prefix.length]);

    return (
        <div>
            <div className="relative">
                <span className="absolute left-3 top-[23px] -translate-y-1/2 text-gray-400 z-10">{prefix}</span>
                <Input
                    type="number"
                    ref={ref}
                    {...rest}
                    className={cn(
                        spaceClassName,
                        '[&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none [-moz-appearance:textfield]',
                        className,
                    )}
                    error={error}
                    onChange={handleChange}
                    min={min}
                    max={max}
                    onBlur={(e) => {
                        const value = e.target.value;
                        const numericValue = parseFloat(value);

                        if (isNaN(numericValue)) {
                            return;
                        }
                        if (hasMax && numericValue > max) {
                            onChange(max.toString());
                            return;
                        }
                        if (hasMin && numericValue < min) {
                            onChange(min.toString());
                            return;
                        }
                    }}
                />
            </div>
        </div>
    );
});

InputCurrency.propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    placeholder: PropTypes.string,
    className: PropTypes.string,
    prefix: PropTypes.string,
    size: PropTypes.oneOf(['normal', 'small']),
    max: PropTypes.number,
    min: PropTypes.number,
    enableClear: PropTypes.bool,
    onClear: PropTypes.func,
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export default InputCurrency;
